import { render, staticRenderFns } from "./BookSummary.vue?vue&type=template&id=752b5cdd&"
import script from "./BookSummary.vue?vue&type=script&lang=js&"
export * from "./BookSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports